import Splide, { Options } from "@splidejs/splide";
import { debounce } from '@utils/debounce';
import { carouselTranslation, setCarouselHeight, setCarouselHeightWhenInViewport } from '@utils/carousel';

export const useGeneralCarousel = () => {
  // Init
  let generalCarouselOptions: Options = {
    speed: 500,
    start: 0,
    focus: 0,
    perMove: 1,
    easing: 'ease',
    drag: true,
    flickPower: 150,
    flickMaxPages: 1,
    keyboard: true,
    updateOnMove: true,
    pagination: false,
    arrows: false,
    mediaQuery: 'min'
  }

  const setUpCarousel = (generalCarousel: HTMLElement): void => {
    const carouselSection = generalCarousel.querySelector(".carousel__wrapper") as HTMLElement;
    const prevArrow = carouselSection.querySelector('.general-carousel-block__arrow--prev') as HTMLElement;
    const nextArrow = carouselSection.querySelector('.general-carousel-block__arrow--next') as HTMLElement;
    const carouselId: string = carouselSection?.id;
    
    if (!carouselId) {
      return;
    }

    // Set carousel translations
    generalCarouselOptions.i18n = carouselTranslation(generalCarousel);
    
    const carousel: Splide = new Splide(`#${carouselId}`, generalCarouselOptions);

    carousel.on('mounted', () => {
      const isFirstSlide = carousel.index === 0;

      prevArrow.classList.toggle('carousel__arrow--hidden', isFirstSlide);

      if (carousel.length == 1) {
        prevArrow.classList.add('carousel__arrow--hidden');
        nextArrow.classList.add('carousel__arrow--hidden');
      }
      
      // Ugly hack to ensure the carousel is loaded before calculating the height. When this block is turned into a section, this won't be needed anymore.
      setTimeout(() => {
        setCarouselHeight(generalCarousel);
      }, 1000);
    });

    carousel.on('move', () => {
      const isFirstSlide = carousel.index === 0;
      const isLastSlide = carousel.index === carousel.length - 1;

      if (prevArrow){
        prevArrow.classList.toggle('carousel__arrow--hidden', isFirstSlide);
      }
      if (nextArrow) {
        nextArrow.classList.toggle('carousel__arrow--hidden', isLastSlide);
      }
    });

    carousel.mount();

    // Go to the previous slide
    generalCarousel.querySelectorAll('button.general-carousel-block__arrow--prev')?.forEach((arrowElement) => {
      arrowElement.addEventListener('click', () => {
        carousel.go('<');
      });
    });

    // Go to the next slide
    generalCarousel.querySelectorAll('.general-carousel-block__arrow--next')?.forEach((arrowElement) => {
      arrowElement.addEventListener('click', () => {
        carousel.go('>');
      });
    });

    setCarouselHeightWhenInViewport(generalCarousel);
  }

  const generalCarousels = document.querySelectorAll('.general-carousel-block') as NodeListOf<HTMLElement>;

  if (generalCarousels.length > 0) {
    generalCarousels.forEach(generalCarousel => {
      setUpCarousel(generalCarousel as HTMLElement);
    });
  }

  // Resize event listener
  window.addEventListener('resize', debounce(() => {
    generalCarousels.forEach(generalCarousel => {
      setCarouselHeight(generalCarousel as HTMLElement);
    });
  }, 250));
}

document.addEventListener('DOMContentLoaded', (): void => {
  useGeneralCarousel();
});